import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TextGeneratorNewLayer from "../components/TextGeneratorNewLayer";

const TextGeneratorNewPage = () => {
  return (
    <>

      {/* Breadcrumb */}
      <Breadcrumb title="Text Generator" />

      {/* TextGeneratorNewLayer */}
      <TextGeneratorNewLayer />

    </>
  );
};

export default TextGeneratorNewPage; 
